<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OUbSdk/tc-custom/9780795350917.jpg?1718077835730" alt="This image is the cover for the book Least of These My Brothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Least of These My Brothers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The “partly autobiographical Christian-themed novel . . . [that] later inspired a young Ronald Reagan to become a Christian” from the bestselling author (Tucson.com).</b><br/><br/> Previously published as <i>That Printer of Udell’s</i>, this is the first novel by Harold Bell Wright, one the most successful turn-of-the-century American writers. Many of his books inspired movies, including <i>The Winning of Barbara Worth </i>starring Gary Cooper and <i>The Shepherd of the Hills</i> starring John Wayne.<br/><br/> In <i>The Least of These My Brothers</i>, Dick Falkner, on his own since the death of his mother, arrives in the bustling mining town of Boyd City. Poor, homeless, and hungry, he’s a printer by trade who lost his job during a Kansas City strike. When a kind print shop owner named Udell gives him a job, Dick lays downs roots in the town, eventually becoming involved in a local church.<br/><br/> Dick’s hardscrabble past gives his faith a different perspective than that of most Christians, and his philosophy is met with resistance. Nevertheless, he rises as a leader in the community, one whose belief in service and championing of the poor will put him at odds with the city’s selfish elite who will stop at nothing to ruin him . . .<br/><br/> “[A] thoroughly good novel.”—<i>The Boston Globe</i><br/><br/> “This novel presents a world that is both frighteningly real and firmly ambitious . . .  the message of Christ is so firmly and wonderfully woven into the story that it makes it sheer joy to read. It’s not just about knowing Christ in this novel, but living Him.”—<i>Christian Book Review</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harold Bell Wright, Michael Phillips
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?425f24eb